import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    uploadCover: 'Загрузить обложку',
    uploadHint: 'PNG, JPG, WebP до 5 МБ',
    cover: 'Обложка',
    replaceCover: 'Заменить обложку',
    titleColor: 'Цвет заголовка',
    pickTitleColor: 'Выбрать цвет заголовка',
    colorFormat: 'Формат цвета: #RGB, #RRGGBB или #RRGGBBAA',
    colorN: (c: string) => `Цвет ${c}`,
    notAnImage: 'Загрузите изображение (PNG, JPG, WEBP)',
    fileTooLarge: (maxMb: number) =>
      `Файл слишком большой: можно загрузить до ${maxMb} МБ. Сожмите картинку или выберите другую.`,
  },
  en: {
    uploadCover: 'Upload cover',
    uploadHint: 'PNG, JPG, WebP up to 5 MB',
    cover: 'Cover',
    replaceCover: 'Replace cover',
    titleColor: 'Title color',
    pickTitleColor: 'Choose title color',
    colorFormat: 'Color format: #RGB, #RRGGBB or #RRGGBBAA',
    colorN: (c: string) => `Color ${c}`,
    notAnImage: 'Upload an image (PNG, JPG, WEBP)',
    fileTooLarge: (maxMb: number) =>
      `File is too large: the limit is ${maxMb} MB. Compress the image or choose another one.`,
  },
})
